import Resource from '@/services/resources/common';

export default class MapResource extends Resource {
  constructor(entrypoint = '/maps', alias = 'Map') {
    super(entrypoint, alias);
  }
}
